import React, { FC, useContext } from 'react'

import {
  DeleteModuleBodyWrapper,
  DeleteModuleTextWrapper,
  DeleteModuleParagraph,
} from './styled'
import { AppModalContext } from '../../../../../../components/AppModal/AppContextModal'
import AppSubmitCancelButtons from '../../../../../../components/AppSubmitCancelButtons'

interface DeleteModuleFormBodyProps {
  handleDeleteContent: () => Promise<void>
  isLoading: boolean
}

const DeleteModuleFormBody: FC<DeleteModuleFormBodyProps> = ({
  handleDeleteContent,
  isLoading,
}: DeleteModuleFormBodyProps) => {
	const modalContext = useContext(AppModalContext)

  const onSubmit = async (): Promise<void> => {
    await handleDeleteContent()
    modalContext.onCloseModal()
  }

  return (
    <DeleteModuleBodyWrapper>
      <DeleteModuleTextWrapper>
        <DeleteModuleParagraph>
          Are you sure you want to delete this module?
        </DeleteModuleParagraph>
        <DeleteModuleParagraph>
          Once you delete it, all the content will be deleted permanently.
        </DeleteModuleParagraph>
      </DeleteModuleTextWrapper>

      <AppSubmitCancelButtons
        saveButtonLabel='Yes, delete'
        onCancel={modalContext?.onCloseModal}
        saveButtonProps={{
          disabled: isLoading,
					onClick: onSubmit,
        }}
        loading={isLoading}
        customWrapperStyles={{
          padding: '1.5rem',
          margin: 'initial',
          borderTop: '1px solid #CDCDD8',
          boxShadow: 'initial',
        }}
        customButtonStyles={{
          width: 'initial',
          maxWidth: 'initial',
        }}
        />
    </DeleteModuleBodyWrapper>
  )
}

export default DeleteModuleFormBody